import { Stack, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import AddressBlock from 'shared/components/AddressBlock';
import TvaNumber from 'shared/components/TvaNumber';
import type { Debtor } from 'types/store/client-state';

import type { InvoiceFormSharedProps } from '../InvoiceForm.types';

type DebtorDetailsProps = InvoiceFormSharedProps & {
  debtor: Debtor;
};

export const DebtorDetails = ({ debtor }: DebtorDetailsProps) => {
  const { t } = useTranslation();

  const {
    address_attributes,
    vat_number,
    co_contractor: isCoContractor,
    intracom: isIntracom,
  } = debtor;

  return (
    <Stack w="100%" justify="end" align="right" ta="right">
      {address_attributes && <AddressBlock address={address_attributes} />}
      {vat_number && (
        <Text>
          {t(i18nKeys.VAT)} : <TvaNumber value={vat_number} />
        </Text>
      )}
      {isCoContractor && <Text size="sm">{t(i18nKeys.INVOICE.REVERSE_CHARGE_COCONTRACTOR)}</Text>}
      {isIntracom && <Text size="sm">{t(i18nKeys.INVOICE.INTRACOMMUNITY)}</Text>}
    </Stack>
  );
};
